import { BaseCrud, IPaging, Static } from 'core-components/types'

interface IGetStaticCrudParams<T> {
  items: T[]
  keyField: string
  pageSize?: IPaging
  hierarchyField?: string
  hierarchyRoot?: string
}

const defaultPaging: IPaging = {
  page: 0,
  pageSize: 2000,
}

export const getStaticCrud = <T>({
  items,
  keyField,
  pageSize = defaultPaging,
  hierarchyRoot,
  hierarchyField,
}: IGetStaticCrudParams<T>) => {
  return new BaseCrud({
    fetcher: new Static(items),
    keyField,
    hierarchyRoot,
    hierarchyField,
    defaultPaging: pageSize,
  })
}
